"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useInterval(callback, delay) {
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        ref.current = callback;
    });
    (0, react_1.useEffect)(() => {
        function tick() {
            if (ref.current !== null) {
                ref.current();
            }
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}
exports.default = useInterval;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLWludGVydmFsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vY29tcG9uZW50cy91dGlscy91c2UtaW50ZXJ2YWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxpQ0FBMEM7QUFJMUMsU0FBd0IsV0FBVyxDQUFDLFFBQTBCLEVBQUUsS0FBb0I7SUFDbEYsTUFBTSxHQUFHLEdBQUcsSUFBQSxjQUFNLEVBQTBCLElBQUksQ0FBQyxDQUFDO0lBRWxELElBQUEsaUJBQVMsRUFBQyxHQUFHLEVBQUU7UUFDYixHQUFHLENBQUMsT0FBTyxHQUFHLFFBQVEsQ0FBQztJQUN6QixDQUFDLENBQUMsQ0FBQztJQUVILElBQUEsaUJBQVMsRUFBQyxHQUFHLEVBQUU7UUFDYixTQUFTLElBQUk7WUFDWCxJQUFJLEdBQUcsQ0FBQyxPQUFPLEtBQUssSUFBSSxFQUFFO2dCQUN4QixHQUFHLENBQUMsT0FBTyxFQUFFLENBQUM7YUFDZjtRQUNILENBQUM7UUFFRCxJQUFJLEtBQUssS0FBSyxJQUFJLEVBQUU7WUFDbEIsSUFBSSxFQUFFLEdBQUcsV0FBVyxDQUFDLElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQztZQUVsQyxPQUFPLEdBQUcsRUFBRSxDQUFDLGFBQWEsQ0FBQyxFQUFFLENBQUMsQ0FBQztTQUNoQztJQUNILENBQUMsRUFBRSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUM7QUFDZCxDQUFDO0FBcEJELDhCQW9CQyJ9